import type {
    IChartShapeProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type { IBorderInfo } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import type {
    IElementModelStyle,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';
import type {
    IShapeModelProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/shape-model-props.interface';
import type { IBackgroundFillInfo } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { shallowMerge } from '@src/slide/domain/ui-model/element-modeles/property/chart/util/merge';


/**
 * 将子节点和父节点的样式进行合并，实现继承样式
 */
export function mergeStyleProps(
    parentProps: IChartShapeProps | undefined,
    childProps: IChartShapeProps | undefined,
): IShapeModelProps {
    const parentStyle = parentProps?.style;
    const childStyle = childProps?.style;

    const mergedBorder = shallowMerge<IBorderInfo>(
        parentStyle?.border || {},
        childStyle?.border || {},
        ['color', 'gradFill', 'noFill'],
    );
    const mergedFillBackground = shallowMerge<IBackgroundFillInfo>(
        parentStyle?.fillBackground || {},
        childStyle?.fillBackground || {},
        ['noFill', 'solidFill', 'gradFill', 'pattFill', 'grpFill', 'image'],
    );

    const mergedStyle = {
        ...parentStyle,
        ...childStyle,
        border: isEmptyObject(mergedBorder) ? undefined : mergedBorder,
        fillBackground: isEmptyObject(mergedFillBackground) ? undefined : mergedFillBackground,
    };

    return {
        ...childProps,
        style: mergedStyle as IElementModelStyle,
    };
}

export function isEmptyObject(object: object) {
    return Object.keys(object).length === 0;
}
